<template>
       <div class="">
        <el-button size="small" type="primary" @click="openFolder" icon="el-icon-folder-add" plain>新建文件夹</el-button>
           
    </div>
</template>

<script>
import { addFolder, checkFileManager } from '@/api/FileManager.js'
export default {
    name: "",
    props: {
        datas: {
            type: Object,
            default: () => { },
        }
    },
    data() {
        return {
        }
    },
    methods: {
        //新建文件夹
        openFolder() {
            this.$prompt('请输入新建文件夹的名称', '新建文件夹', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /^\S+$/, // 修改为不能为空且不能包含空格
                inputErrorMessage: '文件夹的名称不能为空且不能包含空格'
            }).then(async ({ value }) => {
                // 调用添加文件夹接口
                addFolder({
                    path: this.datas.path,
                    T_name: value,
                }).then(({ data: res }) => {
                    console.log('添加文件夹', res);
                    if (res.Code === 200) {
                        this.$message.success('新建文件夹成功');
                        this.$emit('refresh');
                    }
                }).catch((err) => {
                    this.$message.error('新建文件夹失败');
                });
            }).catch(() => { });
        },
    }
}
</script>
<style lang="scss">
/* @import url(); 引入css类 */
</style>